// extracted by mini-css-extract-plugin
export default {"container":"HomePageGetStarted_container__IrZNN"};